import Vue from 'vue'
import PurchaseOrderMaterialsForm from '@js/forms/purchaseOrderMaterials/Form.vue'

if ($('#purchase_order_materials_form').length) {
  new Vue({
    el: '#purchase_order_materials_form',
    components: { PurchaseOrderMaterialsForm }
  })
}
